<template>
  <div class="main">
    <div class="loading" v-if="!failed">
      <van-loading size="50" />
    </div>
    <p class="error-text" role="alert" v-else>{{ errorMessage }}</p>
  </div>
</template>

<script>
import GoogleMapApi from '@/api/google-map-api'
import { GENERIC_MAP_ERROR_MESSAGE } from '@/api/bff/maps'
export default {
  data() {
    return {
      failed: false,
      errorMessage: GENERIC_MAP_ERROR_MESSAGE,
    }
  },
  mounted() {
    GoogleMapApi.clientSideKey().then(res=>{
      let script = document.createElement('script')
      script.id='googleMap'
      script.src = 'https://maps.googleapis.com/maps/api/js?key='+res.data.clientSideKey+'&libraries=places&sensor=true&libraries=drawing,places,geometry,spherical'
      let app = document.getElementById('app')
      // 注意：不要寫成 parent = ...，那會賦值到 window.parent（no-global-assign）
      const parent = app.parentNode;
      if (parent.lastChild == app) {
          parent.appendChild(script);
      } else {
          parent.insertBefore(script, app.nextSibling);
      }
      let url = localStorage.getItem('url')
      localStorage.removeItem('url')
      setTimeout(()=>{
        this.$router.replace({ path:url})
      },500)
      // this.$route
    }).catch(()=>{
      // 只顯示通用文案：不要把上游認證錯誤、X-Api-Key、簽名或請求頭寫進前端日誌
      this.failed = true
    })
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
  position: relative;
  .loading {
    width: 50px;
    height: 50px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .error-text {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    color: #666;
    position: fixed;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
</style>
